import React from 'react'
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import { RecordActionsTabs } from "components/ui/layouts"
import { Title } from "react-admin"
import { Box } from '@mui/material'
import { AuditTable, FieldConfig } from 'components/audit'


const TabList = () => {
    return (
        <Box display="flex" flexDirection="column" width="100%">
           <RecordActionsTabs resourceParent="equipments" />
        </Box>
    )
}

// Пример использования компонента AuditTable на отдельной странице
export const EquipmentAuditHistoryPage = () => {
  const { id } = useParams<{ id: string }>()
  const translate = useTranslate()
  const deviceConfigs: FieldConfig[] = [
    { field: 'name', label: translate("resources.equipments.fields.name"), visible: true },
    { field: 'equipment_kind_id', label: translate("resources.equipments.fields.equipment_kind_id"), visible: true },
    { field: 'props[min]', label: translate("resources.equipments.fields.sensor_min"), visible: true },
    { field: 'props[max]', label: translate("resources.equipments.fields.sensor_max"), visible: true },
    { field: 'props[unit]', label: translate("resources.equipments.fields.sensor_unit"), visible: true },
    { field: 'equipment_driver_id', label: translate("resources.equipments.fields.equipment_driver_id"), visible: true },
    { field: 'manufacturer_company_id', label: translate("resources.equipments.fields.manufacturer_company_id"), visible: true },
    { field: 'energy_kind_id', label: translate("resources.equipments.fields.energy_kind_id"), visible: true },
    { field: 'description', label: translate("resources.common.fields.description"), visible: true },
  ]


  return (
     <>
        <Title title={translate('internal.audit')}/>
        <TabList />
        <AuditTable 
          tableName="equipments"
          recordId={id!}
          showUserColumn={true}
          dense={false}
          className="audit-history-table"
          fieldConfigs={deviceConfigs}
        />
     </>
  )
}

export default EquipmentAuditHistoryPage
